import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'components/Tooltip';
import './style.scss';

const Base = memo(
    ({
        label = '',
        mandatory,
        children,
        className = '',
        parentClassName = '',
        description = '',
        labelMode = '',
    }) => {
        const classes = ['fm-field-container', parentClassName, labelMode || 'horizontal'];

        return (
            <div className={classes.join(' ')}>
                {(label || label === '') && (
                    <span className="fm-field-label">
                        {label}
                        <span className="fm-asterisk-mandatory">{mandatory ? '*' : ''}</span>
                        {description && (
                            <span className="fm-field-description">
                                <Tooltip
                                    containerClassName="fm-field-description-tooltip"
                                    title={description}
                                    position="top"
                                >
                                    <i className="ic-info-filled" />
                                </Tooltip>
                            </span>
                        )}
                    </span>
                )}
                <span className={`fm-field-input ${className || ''}`}>{children}</span>
            </div>
        );
    },
);

Base.propTypes = {
    label: PropTypes.string,
    mandatory: PropTypes.bool,
    className: PropTypes.string,
    parentClassName: PropTypes.string,
    description: PropTypes.string,
    labelMode: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default Base;
